import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function History() {
	const { t } = useTranslation();
	return (
		<div style={{ marginBottom: '100px' }}>
			<div className="row banner" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'orange', backgroundSize: 'cover', backgroundPosition: 'center', height: '400px' }}>
				<img src="./images/maruthi.png" alt="image" style={{ width: '20%' }} />
			</div>
			<div class="container">
				<div class="row" >
					<div className="col-md-12 historybox" >
						<img src="./images/his-1.jpeg" alt="" style={{ width: '100%' }} />
						<h3 className="hheading"></h3>
						<p className="about">
						{t("his-p1")} <br /> <br />
						{t("his-p2")}
						</p>
					</div>
				</div>
				<div class="row" >
					<div className="col-md-4 imagebox" style={{ backgroundImage: 'url(./images/first.jpeg)', backgrooundPosition: 'center', backgroundSize: 'cover' }}>
					</div>
					<div className="col-md-8 historybox" >
						<h3 className="hheading">{t("his-head")}</h3>
						<p className="about">
						{t("his-p3")}
</p>
					</div>
				</div>
				


			</div>

		</div>
	);
}

export default History;
